const app = {
  namespaced: true,
  state: () => ({
    csrfToken: window.appState.csrfToken,
    access_token: window.appState.access_token,
    authenticated: window.appState.authenticated,
    isChatOpen: false,
  }),
  mutations: {
    closeChat: (state) => {
      state.isChatOpen = false;
    },
    openChat: (state) => {
      state.isChatOpen = true;
    },
  },
  preserveState: true,
};
export default app;
